import { ExportType } from '@App/enum/export-type'
import { portalBase2v, rightsholderBase2v, songwriterBase2v } from '@App/dicts/pathes'

export class Report {
    formats = (type: ExportType) => portalBase2v(`report/${type}/formats`)
    export = (rightsholderId: number, exportType: ExportType) =>
        rightsholderBase2v(rightsholderId, `report/${exportType}`)
    songwriterExport = (songwriterId: string, exportType: ExportType) =>
        songwriterBase2v(songwriterId, `report/${exportType}`)
}
